import React from "react";
import SettingsSidebarHeader from "../../../components/common/SettingsSidebarHeader";
import GradientButton from "../../../components/common/UI/GradientButton";
import "./index.scss";

interface MyNumbersProps {
  handleBackToPrevious: () => void;
}
const ResynchronizingChatHistroy: React.FC<MyNumbersProps> = ({
  handleBackToPrevious,
}) => {

  return (
    <div className="resync-chat-container">
      <SettingsSidebarHeader
        title="Resync Chat"
        handleBackClick={handleBackToPrevious}
      />

      <div className="section">
        <img src="/assets/images/resync.svg" className="resync" alt="resync" />

        <div className="flex-container">
          <h1 className="resyn-heading">Resynchronizing Chat Histroy</h1>
          <p className="resyn-discription">
            We Need permission to restore your chat
          </p>
          <GradientButton className="resync-btn">Start</GradientButton>
        </div>
      </div>
    </div>
  );
};

export default ResynchronizingChatHistroy;
